import { graphql } from "~/gql";

export const REPLACE_TEAM_MEMBER = graphql(/* GraphQL */ `
  mutation replaceTeamMember(
    $teamMemberToAdd: TeamMembershipIds!
    $teamMemberToRemove: TeamMembershipIds!
    $matterId: Int!
  ) {
    replaceTeamMember(
      teamMemberToAdd: $teamMemberToAdd
      teamMemberToRemove: $teamMemberToRemove
      matterId: $matterId
    ) {
      teamMemberships {
        ...TeamMembershipParts
      }
      phases {
        ...PhaseParts
      }
      work {
        ...WorkParts
      }
    }
  }
`);
